import { App } from './app'
import { RelatedUser } from './related-user'
import { RelatedUserRole } from './related-role';
import { RelatedCommissionAccounts } from './related-commission-accounts';

export class Role {
    constructor(value?: RelatedUserRole) {
        if (value) {
            this.id = value.userRole_Id;
            this.name = value.name;
        }
    }
    public id: string = null;
    public name: string = null;
    public description: string = null;
    public default: boolean = false;
    public deleted: boolean = false;
    public imageName: string = null;
    public users: RelatedUser[] = [];
    public apps: App[] = [];
    public commissionAccounts: RelatedCommissionAccounts[] = [];
    public createdAt: Date;
    public updatedAt: Date;
    public version: string = null;
}